import { createGqlClient } from "@insightfulscience/shared-utils/gqlClient";
import {
	batch,
	context,
	recovery,
	tap,
} from "@insightfulscience/shared-utils/gqlClient/middlewares";

const gqlClient = ({
	storageService: { token, refreshToken },
	recoveryService: { shouldBeRecovered, recover },
	publicConfig: { GRAPHQL_URI },
	gqlEventsListener,
	apiMock,
	globalContext,
}) =>
	createGqlClient(
		{ uri: GRAPHQL_URI },
		tap(gqlEventsListener),
		recovery(shouldBeRecovered, recover()),
		batch(),
		context((ctx) => ({
			...ctx,
			headers: {
				...ctx.headers,
				...(token.read() != null
					? {
							Authorization: `Bearer ${token.read()}`,
						}
					: {}),
				...(typeof window === "undefined" && refreshToken.read() != null
					? {
							"x-refresh-token": refreshToken.read(),
						}
					: {}), // Send refreshToken only server-side
				"x-mock": apiMock.read() || undefined,
				"x-request-id":
					globalContext?.req?.requestId ?? Math.random().toFixed(20).slice(2),
			},
		})),
	);

export default gqlClient;
